import Arrow from "@/public/assets/images/arrow-circle-left.svg";
import { useSwiper } from "swiper/react";

type GalleryGridButtonsProps = {
  disablePrev: boolean;
  disableNext: boolean;
};

const GalleryGridButtons = ({
  disableNext,
  disablePrev,
}: GalleryGridButtonsProps) => {
  const swiper = useSwiper();
  return (
    <div className="gallery__grid-buttons">
      <button
        className="gallery__grid-button gallery__grid-button--prev"
        onClick={() => {
          swiper.slidePrev();
        }}
        disabled={disablePrev}
      >
        <Arrow />
      </button>
      <button
        className="gallery__grid-button gallery__grid-button--next"
        onClick={() => {
          swiper.slideNext();
        }}
        disabled={disableNext}
      >
        <Arrow />
      </button>
    </div>
  );
};

export default GalleryGridButtons;
